<template>
  <div data-vuetify>
    <v-app>
      <topup-balance :key="formKey" @hideDialog="redrawForm"/>
    </v-app>
  </div>
</template>

<script>
/* eslint-disable indent */
  import TopupBalance from './components/TopupBalance'
  export default {
    name: 'AppForm',
    components: { TopupBalance },
    data: function () {
      return {
        formKey: 0
      }
    },
    methods: {
      redrawForm: function () {
        this.formKey++
      }
    }
  }
</script>

<style>
  .v-application--wrap {
    min-height: 0 !important;
  }
</style>
